import React, { useRef,useContext,useEffect } from 'react';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
// import { useSDK } from "../../scandit/sdk";

export function Attention(props) {

//----------------------------------------
//初期化
//----------------------------------------

const sharedInfo = useContext(SharedInfoContext);
// const { loaded, sdk } = useSDK();

useEffect(() => {
	// (async () => {
	// 	if (loaded) {
	// 		await sdk.enableCamera(true);
	// 	}
	// })();

	document.getElementById('header').classList.add('is_hide');
	// document.getElementById('header').classList.add('is_fixed');
	setTimeout(function(){
		document.getElementById('header').classList.remove('is_hide');
		document.getElementById('header').classList.add('is_behind');
		document.getElementById('header').classList.add('is_fixed');
	// }, 1000);
	}, 50);
	const atime = sharedInfo.storeInfo.attentionkagoUrl.attentionKagoSeconds * 1000;
	setTimeout(function(){
		props.setPage("shopping");
	}, atime);

	//arrows We 対応
	// document.documentElement.style.zoom = window.innerWidth / 390;
	// var zratio = window.innerWidth / 390;
	if(window.innerWidth >= 320){
		document.documentElement.style.zoom = window.innerWidth / 390;
		var zratio = window.innerWidth / 390;
	}else{
		document.documentElement.style.zoom = 1;
		var zratio = 1;
	}
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('shoppingAttention');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}
	// let elementB = document.getElementById('shoppingAttention_img');
	// if (elementB) {
	// 	elementB.style.height = realheight + 'px';
	// }
}, []);

return (
	<>
	<div id="shoppingAttention" className="shoppingAttention">
		<figure id="shoppingAttention_img" className="shoppingAttention_img">
			{/* <img src="/images/home_attention.png" alt="" width="280" height="460"/> */}
			<img src={sharedInfo.storeInfo.attentionkagoUrl.attentionkagoImgAndroidJ} alt="" width="" height=""/>
		</figure>
	</div>
	</>
)

}
